// extracted by mini-css-extract-plugin
export default {"author":"VTUJQdHd","authorInfo":"Nahv0tbe","authorName":"SqB_qiDR","jobTitle":"LTTiTcoL","link":"OGwz2qm3"};